// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"685":"e009b81d","973":"944038be"}[chunkId] + ".chunk.css";
};